import { Filter } from "../../../types/filter";

import {
  Prefix,
  getNonEmptyUniqueSortedOptions,
  handlePrefix,
  isActiveFilter,
  stringOptionFactory,
} from "../utils";

export type ConsigneeAddressQueryParam = "consigneeAddress";
export type SomethingWithConsigneeAddress = {
  consignee?: {
    address?: string;
  } | null;
  delivery?: {
    address?: string;
  } | null;
};

export const getDeliveryAddressFilter = (
  data: SomethingWithConsigneeAddress[],
  prefix?: Prefix
): Filter => ({
  label: "Delivery Address",
  queryParam: handlePrefix("consigneeAddress", prefix),
  options: getNonEmptyUniqueSortedOptions(
    data.map((d) => stringOptionFactory(d.delivery?.address))
  ),
});

export const filterConsigneeAddress = <T extends SomethingWithConsigneeAddress>(
  data: T[],
  filters?: string[]
): T[] =>
  isActiveFilter(filters)
    ? data.filter(({ delivery }) => filters.includes(delivery?.address || ""))
    : data;
